import { useState, useEffect } from "react";
import { GetUser } from "../../Services";

const AddEditDispacher = ({
  editingDispatcher,
  setEditingDispacher,
  setDispatchers,
  setShowModal,
}) => {
  const isEditing = Boolean(editingDispatcher);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    role: "Admin",
    password: "",
  });

  // ✅ Pre-fill form when editing
  useEffect(() => {
    if (editingDispatcher) {
      setFormData(editingDispatcher);
    }
  }, [editingDispatcher]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (isEditing) {
        response = await GetUser.DispatcherUpdate(
          formData,
          editingDispatcher.id
        );
        setDispatchers((prev) =>
          prev.map((d) => (d.id === editingDispatcher.id ? response : d))
        );
      } else {
        response = await GetUser.DispatcherCreate(formData);
        setDispatchers((prev) => [response.data, ...prev]);
      }

      // Reset and close modal
      setEditingDispacher(null);
      setFormData({
        name: "",
        country: "",
        phone: "",
        email: "",
        role: "Admin",
        password: "",
      });
      setShowModal(false);
    } catch (error) {
      console.error("Error saving Dispacher:", error);
    }
  };

  return (
    <div className="content">
      <div className="content-header">
        <h2 className="text-2xl font-bold">
          {isEditing ? "Edit Dispacher" : "New Dispacher"}
        </h2>
      </div>
      <div className="card">
        <form onSubmit={handleSubmit}>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            className="form-control mb-2"
          />
          <input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone"
            className="form-control mb-2"
          />
          <input
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            type="email"
            className="form-control mb-2"
          />
          <input
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Password"
            type="password"
            className="form-control mb-2"
          />
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            className="form-control mb-2"
          >
            <option value="ADMIN">Admin</option>
            <option value="DISPATCHER">Dispacher</option>
          </select>
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">
              {isEditing ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditDispacher;
